import { forwardRef, type Ref, type SVGProps } from "react";
const IconFloodFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M6.363 27.46q-.804.165-1.365-.15-.56-.318-.56-.95 0-.5.455-.965.456-.466 1.435-.933c1.128-.278 2.01-.393 3.057.208q.665.666 1.96.666t1.942-.666 2.678-.666 2.747.666 1.978.666 1.89-.666c1.073-.751 2.592-.292 3.214.06.677.332 1.037.539 1.34.838.303.3.52.751.52 1.084q0 .633-.578.95-.578.315-1.383.15c-1.14-.237-1.66-.756-2.29-.418-.554.297-1.325.666-2.678.666q-2.03 0-2.748-.666-.717-.666-2.012-.666t-1.908.666T11.38 28t-2.748-.666c-.9-.666-1.21-.094-2.269.125m.292-6.12q-.98 0-1.453.416-.471.417-1.277.583-.805.167-1.365-.15Q2 21.873 2 21.24q0-.499.455-.965t1.435-.933q.176-.1.927-.383.753-.283 1.978-.283 1.925 0 2.59.666t1.96.666 1.942-.666 2.678-.666q2.03 0 2.747.666t1.978.666 1.89-.666 2.59-.666q1.226 0 1.977.283.753.285.928.383 1.015.5 1.47.95.455.448.455.948 0 .633-.578.95-.576.315-1.382.15-.806-.168-1.26-.584-.455-.416-1.435-.416-1.294 0-1.942.666t-2.678.666-2.748-.666q-.717-.666-2.012-.666t-1.908.666-2.677.666-2.748-.666-1.977-.666" />
    <path
      fillRule="evenodd"
      d="M10.9 10.142c.23.237.553.372.893.372s.663-.135.893-.372l2.098-2.094v7.519c0 .639.544 1.157 1.215 1.157.672 0 1.216-.518 1.216-1.157V8.048l2.098 2.094c.23.237.554.372.893.372.34 0 .664-.135.894-.372a1.206 1.206 0 0 0 0-1.735l-4.17-4.049a1.387 1.387 0 0 0-1.86 0L10.9 8.407a1.206 1.206 0 0 0 0 1.735"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconFloodFilledSVG);
ForwardRef.displayName = "IconFloodFilled";
export { ForwardRef as IconFloodFilled };
